import { addWithRoundingOrCurrency } from "../../../utils/help/maths/maths";
import { reduxCartAndLoyalty } from "../../../utils/types";
import { TransformOfferTypeObject } from "../types/TypeHelper";

export const checkFranchiseCart = (
  state: reduxCartAndLoyalty,
  franchiseId: number
) => {
  if (state.cart.franchiseId !== franchiseId && state.cart.franchiseId !== -1) {
    console.log("NOT SAME RESTRAUNT RESET CART");
    state.cart = {
      franchiseId: franchiseId,
      items: [],
      totalPrice: 0,
    };
    state.cartItemsNumber = 0;
    if (state.selectedPickupTime !== "") {
      state.selectedPickupTime = "";
    }
  }
  state.cart.franchiseId = franchiseId;

  return state;
};

export const reCalculateCart = (
  state: TransformOfferTypeObject<reduxCartAndLoyalty> | reduxCartAndLoyalty
) => {
  let recalculatedCartTotalPrice = 0;
  if (state.cart) {
    const totalCount = state.cart.items.reduce(
      (total, item) => total + item.count,
      0
    );
    state.cartItemsNumber = totalCount;
    for (let i = 0; i < state.cart.items.length; i++) {
      if (
        !state.isEligibleOffer &&
        state.cart.items[i].discountedItemPercentage &&
        state.cart.items[i].discountedItemPercentage !== 0
      ) {
        continue;
      } else {
        recalculatedCartTotalPrice = addWithRoundingOrCurrency(
          state.hasRoundingMethodAndLevel,
          state.cart.items[i].totalPrice,
          recalculatedCartTotalPrice
        );
      }
    }
  }

  if (state.cart.bundlePrice) {
    recalculatedCartTotalPrice = addWithRoundingOrCurrency(
      state.hasRoundingMethodAndLevel,
      state.cart.bundlePrice,
      recalculatedCartTotalPrice
    );
  }

  state.cart.totalPrice = recalculatedCartTotalPrice;

  return state;
};

// export const calculateMaxCustomDeliveryTime = (state: reduxCartAndLoyalty) => {
//   state.customDeliveryTime = state.cart
//     ? Math.max(
//         ...state.cart.items.map((item) => {
//           return item.customDeliveryTime || 0;
//         }),
//         0
//       )
//     : 0;
// };
